module.exports = "/fonts/vendor/primeicons/primeicons.svg?25954ab5e32c01d577dcafd035597f5d";